// PGCET MCA Mock 8 — General Awareness (questions 71–90)
const pgcetmcaGeneralAwareness = [
  {
    id: 71,
    question: "The river generally regarded as the longest in the world, which drains into the Mediterranean Sea, is the",
    options: ["A. Amazon", "B. Nile", "C. Yangtze", "D. Mississippi"],
    answer: "B"
  },
  {
    id: 72,
    question: "The Strait of Gibraltar connects the Atlantic Ocean with the",
    options: ["A. Red Sea", "B. Black Sea", "C. Mediterranean Sea", "D. Caspian Sea"],
    answer: "C"
  },
  {
    id: 73,
    question: "The Atacama Desert, one of the driest places on Earth, is located mainly in",
    options: ["A. Mexico", "B. Chile", "C. Namibia", "D. Mongolia"],
    answer: "B"
  },
  {
    id: 74,
    question: "The International Date Line roughly follows which meridian of longitude?",
    options: ["A. 0° (Greenwich)", "B. 90° E", "C. 180°", "D. 82.5° E"],
    answer: "C"
  },
  {
    id: 75,
    question: "Lake Baikal, the deepest freshwater lake in the world, is located in",
    options: ["A. Canada", "B. Kazakhstan", "C. Finland", "D. Russia"],
    answer: "D"
  },
  {
    id: 76,
    question: "The Great Barrier Reef, the world's largest coral reef system, lies off the coast of",
    options: ["A. Australia", "B. Indonesia", "C. the Philippines", "D. New Zealand"],
    answer: "A"
  },
  {
    id: 77,
    question: "The International Court of Justice, the principal judicial organ of the United Nations, is located in",
    options: ["A. Geneva", "B. New York", "C. The Hague", "D. Vienna"],
    answer: "C"
  },
  {
    id: 78,
    question: "The permanent secretariat of the South Asian Association for Regional Cooperation (SAARC) is located in",
    options: ["A. Kathmandu", "B. New Delhi", "C. Dhaka", "D. Colombo"],
    answer: "A"
  },
  {
    id: 79,
    question: "Which of the following countries is NOT a permanent member of the United Nations Security Council?",
    options: ["A. France", "B. China", "C. Germany", "D. Russia"],
    answer: "C"
  },
  {
    id: 80,
    question: "The World Health Organization (WHO) came into existence in the year",
    options: ["A. 1945", "B. 1948", "C. 1950", "D. 1946"],
    answer: "B"
  },
  {
    id: 81,
    question: "India's first satellite, Aryabhata, was launched in 1975 with the help of",
    options: ["A. the United States", "B. the Soviet Union", "C. France", "D. Japan"],
    answer: "B"
  },
  {
    id: 82,
    question: "India's Mars Orbiter Mission (Mangalyaan) was launched by ISRO in the year",
    options: ["A. 2011", "B. 2008", "C. 2016", "D. 2013"],
    answer: "D"
  },
  {
    id: 83,
    question: "Chandrayaan-1, India's first lunar probe, which helped confirm the presence of water molecules on the Moon, was launched in",
    options: ["A. 2008", "B. 2010", "C. 2012", "D. 2005"],
    answer: "A"
  },
  {
    id: 84,
    question: "The Satish Dhawan Space Centre, ISRO's main spaceport, is located at",
    options: ["A. Sriharikota, Andhra Pradesh", "B. Thumba, Kerala", "C. Balasore, Odisha", "D. Mahendragiri, Tamil Nadu"],
    answer: "A"
  },
  {
    id: 85,
    question: "Penicillin, the first widely used antibiotic, was discovered in 1928 by",
    options: ["A. Louis Pasteur", "B. Alexander Fleming", "C. Edward Jenner", "D. Robert Koch"],
    answer: "B"
  },
  {
    id: 86,
    question: "The World Wide Web was invented in 1989 by",
    options: ["A. Vint Cerf", "B. Charles Babbage", "C. Bill Gates", "D. Tim Berners-Lee"],
    answer: "D"
  },
  {
    id: 87,
    question: "The neutron was discovered in 1932 by",
    options: ["A. J.J. Thomson", "B. Ernest Rutherford", "C. James Chadwick", "D. Niels Bohr"],
    answer: "C"
  },
  {
    id: 88,
    question: "The Raman Effect, discovered by Sir C.V. Raman in 1928, is related to the",
    options: [
      "A. scattering of light by molecules",
      "B. emission of electrons from metals by light",
      "C. radioactive decay of nuclei",
      "D. loss of electrical resistance at low temperatures"
    ],
    answer: "A"
  },
  {
    id: 89,
    question: "The classic short-story collection 'Malgudi Days' was written by",
    options: ["A. Mulk Raj Anand", "B. Raja Rao", "C. R.K. Narayan", "D. Ruskin Bond"],
    answer: "C"
  },
  {
    id: 90,
    question: "The classic English novel 'Pride and Prejudice' was written by",
    options: ["A. Charlotte Brontë", "B. George Eliot", "C. Emily Brontë", "D. Jane Austen"],
    answer: "D"
  }
];

export default pgcetmcaGeneralAwareness;
